export default {
  pageTitle: 'About Us',
  metaDescription: 'Learn about PT Tokki Engineering and Fabrication (TEF), an Indonesian pressure vessel and heat exchanger manufacturer established in 2019, backed by Tokki Ltd Japan.',
  hero: { title: 'About Us' },
  companyInfo: {
    dateEstablished: 'Date established',
    capital: 'Capital',
    shareholder: 'Shareholder',
    presidentDirector: 'President Director',
    totalEmployee: 'Total employee',
    bank: 'Bank',
    emailAddress: 'Email address',
  },
  overview: {
    toggleLabel: 'Company Overview',
    paragraph1:
      'Founded in 2019, PT Tokki Engineering and Fabrication (TEF) is a subsidiary of TOKKI LTD., established to provide high-quality fabricated products at competitive prices to customers worldwide. Based in Indonesia, TEF specializes in manufacturing <b>welded pressure vessels and sheet metal components</b> for various industrial sectors, including <b>Oil & Gas, Petrochemicals, Pharmaceuticals, Fertilizer, Power Plants, and Thermal Processing industries</b>.',
    paragraph2:
      "With a strong commitment to <strong>engineering excellence, consulting expertise, advanced welding techniques, and special materials handling</strong>, TEF continuously innovates to meet the ever-evolving demands of the industry.",
  },
  specialization: {
    toggleLabel: 'Our Specialization',
    paragraph:
      'TEF is highly experienced in fabricating products using <b>stainless steel, nickel-based alloys, titanium, and other exotic materials.</b> Our expertise ensures durability, precision, and compliance with international standards.',
  },
  values: {
    toggleLabel: 'Our Values',
    item1: {
      title: '1. One-Stop Engineering & Fabrication Services',
      desc: "We provide a fully integrated solution — from engineering consultation and design to fabrication, inspection, and delivery — ensuring efficiency, coordination, and quality at every stage. TEF can also perform reconditioning and service work, both at our workshops and directly on-site at the customer's location.",
    },
    item2: {
      title: '2. Expertise in Special & High-Performance Materials',
      desc: 'Our experience with stainless steel, nickel alloys, titanium, and other exotic materials allows us to deliver durable, high-performance products for critical process industries.',
    },
    item3: {
      title: '3. Certified Quality & Engineering Precision',
      desc: 'Backed by international certifications such as ISO 9001:2015 and ASME U & R Stamp, our processes are designed for accuracy, reliability, and strict compliance with global standards.',
    },
    item4: {
      title: '4. Cost-Effective, Long-Term Solutions',
      desc: 'We aspire to be a solution provider that minimizes maintenance costs in the process industry. We strive to be a strategic partner by offering smart fabrication solutions that reduce long-term maintenance needs and enhance operational stability.',
    },
    item5: {
      title: '5. Customer Satisfaction Through Reliable Delivery',
      desc: 'Our commitment is clear: deliver high-quality products, on-time, and at competitive prices — ensuring each client receives consistent value and dependable support.',
    },
  },
  visionMission: {
    heading: 'Vision & Mission',
    vision: {
      title: 'Vision',
      item1:
        'We bring together Mastery Meets Innovation to solve corrosion issues and other process industry problems in one place.',
      item2: 'We aim to become a trusted, one-stop leading fabricator that gives everyone peace of mind.',
    },
    mission: {
      title: 'Mission',
      item1:
        'We build strong trust and create new possibilities in the process industry with mastery, innovation, a passion for challenges, and honesty.',
      item2:
        'We combine craftsmanship with advanced technology to provide high-quality products and services. Our goal is to ensure stable operations and peace of mind for our customers while continuously bringing new value to their businesses.',
      item3:
        'We embrace challenges and drive change with passion. By doing so, we shape an exciting future that inspires the process industry and leads to continuous growth and innovation.',
    },
  },
  qualityPolicy: {
    heading: 'Quality Policy',
    commitmentTitle: 'Commitment to Continuous Improvement',
    commitmentDesc:
      'We are committed to continuously improving our Quality Management System to enhance customer satisfaction <br> and operational excellence.',
    ourCommitmentsHeading: 'Our Commitments:',
    commitment1: '1. Foster teamwork to achieve quality objectives.',
    commitment2: '2. Adopt a customer-centric approach by delivering:',
    deliverList: {
      item1: 'High-quality, reliable products',
      item2: 'On-time delivery',
      item3: 'High value, reasonable price – engineered with integrity',
      item4: 'Responsive technical and commercial service',
    },
    accountabilityHeading: 'Accountability & Compliance:',
    accountabilityList: {
      item1: 'Ensure compliance with ISO 9001:2015, regulations, and stakeholder expectations.',
      item2: 'Empower Quality Assurance personnel to act on any quality issues without restrictions.',
      item3: 'Involve every employee in maintaining and improving quality standards.',
    },
    structureHeading: 'Structured System & Responsibility:',
    structureList: {
      item1: 'A comprehensive Quality Manual guides our quality practices.',
      item2: 'All employees must adhere to quality procedures and contribute through effective collaboration.',
      item3: 'New hires undergo structured training.',
      item4: 'Section Managers ensure safety and quality practices are implemented and understood.',
    },
  },
  parentCompany: {
    heading: 'Parent Company',
    desc1: 'Parent company of PT. Tokki Engineering and Fabrication is Tokki Co,. Ltd',
    desc2: 'Detail of the company and business of Tokki Co,. Ltd is as shown in the following website :',
  },
};
